import { useQueryWithUserId } from '@northladder/services';

import { EXTERNAL_API } from '../externalApiClient';
import { ITermsAndConditionParams } from '../types';

/**
 * This is to track the terms and condition state
 */
const TERMS_AND_CONDITION_QUERY = 'terms-and-condition-query';

export const useGetTermsAndConditionQuery = ({
  countryCode,
  language,
}: ITermsAndConditionParams) => {
  const { data, isError, error, isLoading, refetch } = useQueryWithUserId({
    queryKey: [TERMS_AND_CONDITION_QUERY, countryCode, language],
    retry: 3,
    queryFn: () =>
      EXTERNAL_API.fetchTermsAndConditions({ countryCode, language }),
  });

  return {
    data,
    isError,
    error,
    isLoading,
    refetch,
  };
};
